export default __webpack_public_path__ + "static/media/info-circle.e6f927ec.svg";